import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { PrimeIcons } from 'primeng/api';

@Component({
  selector: 'app-application-context-card',
  imports: [NgClass],
  templateUrl: './application-context-card.component.html',
  styleUrl: './application-context-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApplicationContextCardComponent {
  public title = input<string | null>();
  public description = input<string | null>();
  public icon = input<string | null>(PrimeIcons.BRIEFCASE);
}
